import _extends from "@babel/runtime/helpers/esm/extends";
import { ChartsLoadingOverlay } from './ChartsLoadingOverlay';
import { useSeries } from '../hooks/useSeries';
import { ChartsNoDataOverlay } from './ChartsNoDataOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
export function useNoData() {
  const seriesPerType = useSeries();
  return Object.values(seriesPerType).every(seriesOfGivenType => {
    if (!seriesOfGivenType) {
      return true;
    }
    const series = seriesOfGivenType.series,
      seriesOrder = seriesOfGivenType.seriesOrder;
    return seriesOrder.every(seriesId => series[seriesId].data.length === 0);
  });
}
export function ChartsOverlay(props) {
  const noData = useNoData();
  if (props.loading) {
    var _props$slots$loadingO, _props$slots, _props$slotProps;
    const LoadingOverlay = (_props$slots$loadingO = (_props$slots = props.slots) === null || _props$slots === void 0 ? void 0 : _props$slots.loadingOverlay) !== null && _props$slots$loadingO !== void 0 ? _props$slots$loadingO : ChartsLoadingOverlay;
    return /*#__PURE__*/_jsx(LoadingOverlay, _extends({}, (_props$slotProps = props.slotProps) === null || _props$slotProps === void 0 ? void 0 : _props$slotProps.loadingOverlay));
  }
  if (noData) {
    var _props$slots$noDataOv, _props$slots2, _props$slotProps2;
    const NoDataOverlay = (_props$slots$noDataOv = (_props$slots2 = props.slots) === null || _props$slots2 === void 0 ? void 0 : _props$slots2.noDataOverlay) !== null && _props$slots$noDataOv !== void 0 ? _props$slots$noDataOv : ChartsNoDataOverlay;
    return /*#__PURE__*/_jsx(NoDataOverlay, _extends({}, (_props$slotProps2 = props.slotProps) === null || _props$slotProps2 === void 0 ? void 0 : _props$slotProps2.noDataOverlay));
  }
  return null;
}